// extracted by mini-css-extract-plugin
var _1 = "ue7iZ";
var _2 = "Qufji";
var _3 = "sarII";
export { _1 as "base", _2 as "diff", _3 as "icon" }
